import { FC } from 'react';

import { Button } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import Icon from '@telialt/common-icon/src';
import { isEmpty } from '@telialt/utils/src/helpers';
import { isIOS } from '@telialt/utils/src/responsive';

import { GOOGLE_MAPS } from '../../constants';
import { RetailsTestID } from '../../test-ids';
import { useRetailsContext } from '../RetailsContext';
import {
    AttributeRow,
    AttributesContainer,
    SalonAlert,
    SalonInfoContainer,
    SalonInfoWrapper,
    SalonTitle,
    WorkTimesList,
} from './SalonInfo.styles';
import { WorkTimeItem } from './WorkTimeItem';

export const SalonInfo: FC = () => {
    const { t } = useTranslations();

    const { selectedSalon, animatedSalonCardId } = useRetailsContext();

    if (!selectedSalon) {
        return null;
    }

    const handleNavigateClick = () => {
        if (isIOS()) {
            window.open(`${GOOGLE_MAPS.dirUrlApple}${selectedSalon.lat},${selectedSalon.lng}`);
        } else {
            window.open(`${GOOGLE_MAPS.dirUrl}${selectedSalon.lat},${selectedSalon.lng}`, '_blank');
        }
    };

    return (
        <SalonInfoWrapper $isAnimated={animatedSalonCardId === selectedSalon.id} data-test={RetailsTestID.SALON_INFO}>
            <SalonInfoContainer>
                <SalonTitle>{selectedSalon.shop}</SalonTitle>
                {selectedSalon.alert && (
                    <SalonAlert data-test={RetailsTestID.SALON_INFO_ALERT}>{selectedSalon.alert}</SalonAlert>
                )}
                <WorkTimesList>
                    <WorkTimeItem
                        daysLabel={t['retails_map.worktime.weekdays']}
                        openHours={selectedSalon.openHours}
                        lunchHours={selectedSalon.lunchHours}
                    />
                    <WorkTimeItem
                        daysLabel={t['retails_map.worktime.saturday']}
                        openHours={selectedSalon.saturdayOpenHours}
                        lunchHours={selectedSalon.saturdayLunchHours}
                    />
                    <WorkTimeItem
                        daysLabel={t['retails_map.worktime.sunday']}
                        openHours={selectedSalon.sundayOpenHours}
                        lunchHours={selectedSalon.sundayLunchHours}
                    />
                </WorkTimesList>
                {!isEmpty(selectedSalon.salonAttributeList) && (
                    <AttributesContainer>
                        {selectedSalon.salonAttributeList.map((attribute, index) => (
                            <AttributeRow key={index}>
                                <div>{attribute.name}</div>
                                <Icon type={attribute.icon} style={{ fontSize: 24 }} />
                            </AttributeRow>
                        ))}
                    </AttributesContainer>
                )}
                <div>
                    <Button variant="primary" fullWidth={true} onClick={handleNavigateClick}>
                        {t['retails_map.worktime.navigate']}
                    </Button>
                </div>
            </SalonInfoContainer>
        </SalonInfoWrapper>
    );
};
